<template>
  <a-row :gutter="24">
    <a-col :span="24">
      <a-form-model-item label="标的名称" prop="objectName">
        <a-input
          v-model="form.projectName"
          placeholder="请输入标的名称"
          disabled
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="租赁期限" prop="leaseTerm">
        <a-form-model-item
          prop="leaseTerm"
          :style="{
            display: 'inline-block',
            width: 'calc(100% - 150px)',
          }"
        >
          <a-input v-model="form.leaseTerm" placeholder="请输入租赁期限" />
        </a-form-model-item>
        <span
          :style="{
            display: 'inline-block',
            width: '20px',
            textAlign: 'center',
          }"
        >
        </span>
        <a-form-model-item
          prop="leaseTermUnit"
          :style="{
            display: 'inline-block',
            width: '130px',
          }"
        >
          <a-radio-group v-model="form.leaseTermUnit" button-style="solid">
            <a-radio-button :value="1"> 个月 </a-radio-button>
            <a-radio-button :value="2"> 年 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="出租底价(首年)" prop="floorPrice">
        <a-form-model-item
          prop="floorPrice"
          :style="{
            display: 'inline-block',
            width: 'calc(100% - 150px)',
          }"
        >
          <template v-slot:extra v-if="form.rentalPriceType == 2">
            出租底价平台在信息发布期满后方可查看
          </template>
          <a-input v-model="form.floorPrice" placeholder="请输入出租底价" />
        </a-form-model-item>
        <span
          :style="{
            display: 'inline-block',
            width: '20px',
            textAlign: 'center',
          }"
        >
        </span>
        <a-form-model-item
          prop="rentTimeEnd"
          :style="{
            display: 'inline-block',
            width: '130px',
          }"
        >
          <a-radio-group v-model="form.floorPriceeUnit" button-style="solid">
            <a-radio-button :value="1"> 元/月 </a-radio-button>
            <a-radio-button :value="2"> 元/年 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="出租价格类型" prop="rentalPriceType">
            <a-radio-group v-model="form.rentalPriceType">
              <a-radio :value="1">公示出租底价</a-radio>
              <a-radio :value="2">公示出租底价价格区间</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12" v-if="form.rentalPriceType == 1">
          <a-form-model-item
            label="出租底价公开范围"
            prop="rentalBasePriceDisclosureScope"
          >
            <a-radio-group v-model="form.rentalBasePriceDisclosureScope">
              <a-radio :value="1">全网公开</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24" v-if="form.rentalPriceType == 2">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            label="出租底价价格区间（下限）"
            prop="rentalBasePriceRangeMin"
          >
            <a-form-model-item
              prop="rentalBasePriceRangeMin"
              :style="{
                display: 'inline-block',
                width: 'calc(100% - 150px)',
              }"
            >
              <a-input
                v-model="form.rentalBasePriceRangeMin"
                placeholder="请输入出租底价价格区间（下限）"
              />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '20px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              prop="rentTimeEnd"
              :style="{
                display: 'inline-block',
                width: '130px',
              }"
            >
              <a-radio-group
                v-model="form.floorPriceeUnit"
                button-style="solid"
              >
                <a-radio-button :value="1"> 元/月 </a-radio-button>
                <a-radio-button :value="2"> 元/年 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item
            label="出租底价价格区间（上限）"
            prop="rentalBasePriceRangeMax"
          >
            <a-form-model-item
              prop="rentalBasePriceRangeMax"
              :style="{
                display: 'inline-block',
                width: 'calc(100% - 150px)',
              }"
            >
              <template v-slot:extra>
                出租底价上限不得高于下限价格10倍
              </template>
              <a-input
                v-model="form.rentalBasePriceRangeMax"
                placeholder="请输入出租底价价格区间（上限）"
              />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '20px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              prop="rentTimeEnd"
              :style="{
                display: 'inline-block',
                width: '130px',
              }"
            >
              <a-radio-group
                v-model="form.floorPriceeUnit"
                button-style="solid"
              >
                <a-radio-button :value="1"> 元/月 </a-radio-button>
                <a-radio-button :value="2"> 元/年 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col
      :span="24"
      style="color: red; margin: 10px 0px"
      v-if="form.rentalPriceType == 2"
    >
      本项目出租底价须在价格区间范围内。并按照公告约定的出租底价公示时间在意向承租方账号中显示。若产生竞价，出租底价为竞价底价。意向承租方在查看出租底价后可选择退出，若所有意向承租方均退出的，招租活动终结。
    </a-col>

    <a-col :span="24" style="color: red" v-if="form.rentalPriceType == 2">
      <a-form-model-item
        label="出租底价公示时间"
        prop="rentalBasePricePublicTime"
      >
        <a-radio-group v-model="form.rentalBasePricePublicTime">
          <a-radio :value="1">仅向报名且交纳保证金的意向承租方公开</a-radio>
          <a-radio :value="2"
            >仅向报名且经出租方确认获得遴选资格的意向承租方公开</a-radio
          >
        </a-radio-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="出租价格说明">
        <a-input
          placeholder="若以年租金为出租底价，该价格不含免租期，一年按365日计，月租金按照年租金除以12计算"
          disabled
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="租金参考价" prop="referenceRentPrice">
        <template v-slot:extra>
          <span style="color: red">
            本信息仅供参考，不构成出租方或平台对出租标的的任何要约、承诺或保证。
          </span>
        </template>
        <a-input
          v-model="form.referenceRentPrice"
          disabled
          placeholder="本信息仅供参考，不构成出租方或平台对出租标的的任何要约、承诺或保证。"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="公告展示租金单价" prop="showRentalUnitPrice">
        <a-radio-group v-model="form.showRentalUnitPrice">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            label="是否存在定价依据"
            prop="hasExistPricingBasis"
          >
            <a-radio-group v-model="form.hasExistPricingBasis">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12" v-if="form.hasExistPricingBasis == 1">
          <a-form-model-item label="定价依据说明" prop="pricingBasis">
            <a-radio-group v-model="form.pricingBasis">
              <a-radio :value="1">评估</a-radio>
              <a-radio :value="2">市场估价</a-radio>
              <a-radio :value="3">询价</a-radio>
              <a-radio :value="4">其他</a-radio>
            </a-radio-group>
            <a-form-model-item
              prop="pricingBasisOther"
              v-if="form.pricingBasis === 4"
            >
              <a-input
                v-model="form.pricingBasisOther"
                placeholder="请输入定价依据说明"
              />
            </a-form-model-item>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="计租数量(租赁面积)" prop="rentCount">
        <a-input
          v-model="form.rentCount"
          disabled
          placeholder="请输入计租数量"
          suffix="平方米"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item
        label="集团参考价(首年)"
        prop="enterpriseFirstYearPricing"
      >
        <a-form-model-item
          prop="enterpriseFirstYearPricing"
          :style="{
            display: 'inline-block',
            width: 'calc(100% - 150px)',
          }"
        >
          <a-input
            v-model="form.enterpriseFirstYearPricing"
            placeholder="请输入集团参考价"
          />
        </a-form-model-item>
        <span
          :style="{
            display: 'inline-block',
            width: '20px',
            textAlign: 'center',
          }"
        >
        </span>
        <a-form-model-item
          prop="rentTimeEnd"
          :style="{
            display: 'inline-block',
            width: '130px',
          }"
        >
          <a-radio-group
            v-model="form.enterprisePricingUnit"
            button-style="solid"
          >
            <a-radio-button :value="1"> 元/月 </a-radio-button>
            <a-radio-button :value="2"> 元/年 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="是否涉及租金调整" prop="hasRentAdjustments">
            <a-radio-group v-model="form.hasRentAdjustments">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12" v-if="form.hasRentAdjustments == 1">
          <a-form-model-item label="租金调整方式" prop="rentAdjustmentWay">
            <a-textarea
              placeholder="例：每 x 年递增 x % "
              v-model="form.rentAdjustmentWay"
              :rows="1"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="是否有免租期" prop="hasRentFreePeriod">
            <a-radio-group v-model="form.hasRentFreePeriod">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24" v-if="form.hasRentFreePeriod == 1">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="免租期时间" prop="rentFreePeriod">
            <a-form-model-item
              prop="rentFreePeriod"
              :style="{
                display: 'inline-block',
                width: 'calc(100% - 150px)',
              }"
            >
              <a-input-number
                :min="1"
                :precision="0"
                style="width: 100%"
                placeholder="请输入免租期时间"
                v-model="form.rentFreePeriod"
              />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '20px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              prop="rentFreePeriodUnit"
              :style="{
                display: 'inline-block',
                width: '130px',
              }"
            >
              <a-radio-group
                v-model="form.rentFreePeriodUnit"
                button-style="solid"
              >
                <a-radio-button :value="1"> 日 </a-radio-button>
                <a-radio-button :value="2"> 个月 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item
            label="租赁期限是否含免租期"
            prop="hasRentContainFreePeriod"
          >
            <a-radio-group v-model="form.hasRentContainFreePeriod">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="租赁类型" prop="leaseType">
        <a-checkbox-group v-model="form.leaseType" style="width: 100%">
          <a-row :gutter="[0, 12]">
            <a-col :span="3" v-for="item in dictionaries.leaseTypeList" :key="item.value">
              <a-checkbox :value="item.value">{{ item.note }}</a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="租赁用途" prop="rentalUse">
        <template v-slot:extra>
          <span style="color: red">
            风险提示：证载用途与租赁用途不一致，承租方承租后如需办理营业执照等事项，相应风险需自行承担。
          </span>
        </template>
        <a-checkbox-group v-model="form.rentalUse" style="width: 100%" disabled>
          <a-row :gutter="[0, 12]">
            <a-col
              :span="3"
              v-for="item in dictionaries.leaseUseType"
              :key="item.value"
            >
              <a-checkbox :value="item.value">{{ item.note }}</a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="24" v-if="form.rentalUse.includes('16384')">
      <a-form-model-item label="其他租赁用途说明" prop="rentalUseDesc">
        <a-input
          v-model="form.rentalUseDesc"
          placeholder="请输入其他租赁用途说明"
          disabled
        />
      </a-form-model-item>
    </a-col>

    <a-col
      :span="24"
      v-if="form.rentalUse.includes('1') || form.rentalUse.includes('8')"
    >
      <a-row :gutter="24">
        <a-col :span="12" v-if="form.rentalUse.includes('1')">
          <a-form-model-item label="商业细分业态" prop="businessCategories">
            <a-input
              v-model="form.businessCategories"
              placeholder="请输入商业细分业态"
            />
          </a-form-model-item>
        </a-col>

        <a-col :span="12" v-if="form.rentalUse.includes('8')">
          <a-form-model-item label="园区细分业态" prop="parkCategories">
            <a-input
              v-model="form.parkCategories"
              placeholder="请输入园区细分业态"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="业态要求" prop="formatRequirements">
        <a-input
          v-model="form.formatRequirements"
          placeholder="此处可填写倾向业态与禁止业态"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-form-model-item
        label="政策推介"
        prop="policyRecommendations"
        extra="注：政策介绍内容不允许有外部链接。"
      >
        <a-textarea
          v-model="form.policyRecommendations"
          placeholder="请输入政策推介"
          :rows="1"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="装修现状" prop="currentSituationDecoration">
        <a-select
          v-model="form.currentSituationDecoration"
          placeholder="请选择装修现状"
        >
          <a-select-option :value="1">精装</a-select-option>
          <a-select-option :value="2">毛坯</a-select-option>
          <a-select-option :value="3">简装</a-select-option>
          <a-select-option :value="4">拎包入住</a-select-option>
        </a-select>
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="是否允许装修改造" prop="allowRemodeling">
        <a-radio-group v-model="form.allowRemodeling">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="24" v-if="form.allowRemodeling == 1">
      <a-form-model-item label="装修改造说明" prop="remodelingDesc">
        <a-input
          v-model="form.remodelingDesc"
          placeholder="请输入装修改造说明"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="是否有停车位" prop="parkingSpaceAvailable">
            <a-radio-group v-model="form.parkingSpaceAvailable">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12" v-if="form.parkingSpaceAvailable == 1">
          <a-form-model-item label="停车位个数" prop="numberParkingSpaces">
            <a-form-model-item
              prop="numberParkingSpaces"
              :style="{
                display: 'inline-block',
                width: 'calc(100% - 150px)',
              }"
            >
              <a-input-number
                :min="0"
                :precision="0"
                style="width: 100%"
                v-model="form.numberParkingSpaces"
                placeholder="请输入停车位个数"
              />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '10px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              prop="rentTimeEnd"
              :style="{
                display: 'inline-block',
                width: '60px',
              }"
            >
              <a-radio-group default-value="a" button-style="solid">
                <a-radio-button value="a"> 个 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="是否可转租" prop="sublease">
            <a-radio-group v-model="form.sublease">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24" v-if="form.sublease == 1">
      <a-form-model-item label="转租说明" prop="subleaseDesc">
        <a-textarea
          v-model="form.subleaseDesc"
          :rows="1"
          placeholder="请输入转租说明"
        />
      </a-form-model-item>
    </a-col>
  </a-row>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      dictionaries: {
        leaseTypeList: [
          {
            value: "1",
            note: "房屋",
            classify: "ZLPT_ZLLX",
          },
          {
            value: "2",
            note: "场地",
            classify: "ZLPT_ZLLX",
          },
        ],
        leaseUseType: [
          {
            value: "1",
            note: "商业",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "2",
            note: "楼宇办公",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "8",
            note: "园区",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "16",
            note: "仓储",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "32",
            note: "厂房",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "64",
            note: "酒店",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "256",
            note: "住宅",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "512",
            note: "公寓",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "1024",
            note: "工业",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "2048",
            note: "农用",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "4096",
            note: "市政配套",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "8192",
            note: "场地",
            classify: "ZLPT_ZLYT",
          },
          {
            value: "16384",
            note: "其他",
            classify: "ZLPT_ZLYT",
          },
        ],
      },
    };
  },

  watch: {
    // 出租价格类型切换
    "form.rentalPriceType": {
      handler(val) {
        if (Number(val) === 1) {
          // 切到单价模式时，清空区间值
          this.form.floorPrice = undefined;
          this.form.rentalBasePriceRangeMin = undefined;
          this.form.rentalBasePriceRangeMax = undefined;
        } else if (Number(val) === 2) {
          // 切到区间模式时，清空单值
          this.form.floorPrice = undefined;
        }
        this.updateReferenceRentPrice();
      },
      immediate: true,
    },

    // 单值模式相关
    "form.floorPrice"() {
      this.updateReferenceRentPrice();
    },

    // 单位变化也会影响结果
    "form.floorPriceeUnit"() {
      this.updateReferenceRentPrice();
    },

    // 区间模式相关
    "form.rentalBasePriceRangeMin"() {
      this.updateReferenceRentPrice();
    },
    "form.rentalBasePriceRangeMax"() {
      this.updateReferenceRentPrice();
    },

    // 面积变化也会影响结果
    "form.rentCount"() {
      this.updateReferenceRentPrice();
    },
  },
  methods: {
    /**
     * 判断是否有值
     */
    isNotEmpty(val) {
      return val !== undefined && val !== null && String(val).trim() !== "";
    },

    /**
     * 统一将价格换算成 元/平/天
     * unit:
     * 1 = 元/月
     * 2 = 元/年
     *
     * 计算规则：
     * 元/月 -> price / area / 30
     * 元/年 -> price / area / 365
     *
     * 无法计算时返回空字符串
     */
    convertToReferencePrice(price, unit, area) {
      if (!this.isNotEmpty(price) || !this.isNotEmpty(area)) {
        return "";
      }

      const priceNum = Number(String(price).trim());
      const areaNum = Number(String(area).trim());
      const unitNum = Number(unit);

      // 防御：价格必须是数字
      if (isNaN(priceNum)) {
        return "";
      }

      // 防御：面积必须是有效数字且大于0
      if (isNaN(areaNum) || areaNum <= 0) {
        return "";
      }

      let result = "";

      if (unitNum === 1) {
        // 元/月 -> 元/平/天
        result = priceNum / areaNum / 30;
      } else if (unitNum === 2) {
        // 元/年 -> 元/平/天
        result = priceNum / areaNum / 365;
      } else {
        return "";
      }

      // 保留两位小数
      return result.toFixed(2);
    },

    /**
     * 更新租金参考价
     */
    updateReferenceRentPrice() {
      const {
        rentalPriceType,
        floorPrice,
        floorPriceeUnit,
        rentalBasePriceRangeMin,
        rentalBasePriceRangeMax,
        rentCount,
      } = this.form;

      const finalUnitText = "元/平/天";

      // 情况1：公示出租底价
      if (Number(rentalPriceType) === 1) {
        const convertedPrice = this.convertToReferencePrice(
          floorPrice,
          floorPriceeUnit,
          rentCount
        );

        this.form.referenceRentPrice = convertedPrice
          ? `${convertedPrice}${finalUnitText}`
          : undefined;
        return;
      }

      // 情况2：公示出租底价价格区间
      if (Number(rentalPriceType) === 2) {
        const hasMin = this.isNotEmpty(rentalBasePriceRangeMin);
        const hasMax = this.isNotEmpty(rentalBasePriceRangeMax);

        // 上下限都没填，则整体不显示
        if (!hasMin && !hasMax) {
          this.form.referenceRentPrice = undefined;
          return;
        }

        const minText = hasMin
          ? this.convertToReferencePrice(
              rentalBasePriceRangeMin,
              floorPriceeUnit,
              rentCount
            ) || "--"
          : "--";

        const maxText = hasMax
          ? this.convertToReferencePrice(
              rentalBasePriceRangeMax,
              floorPriceeUnit,
              rentCount
            ) || "--"
          : "--";

        this.form.referenceRentPrice = `${minText}~${maxText}${finalUnitText}`;
        return;
      }

      this.form.referenceRentPrice = undefined;
    },
  },
};
</script>

<style>
</style>